import React from 'react';
import Resources from '../pages/Resources';
import code from '../images/code.jpg';


const Software = () => {
  return (
    <div className="full-div-code-view" style={{ marginLeft: '201px', marginRight: '1px', paddingLeft: '30px', paddingBottom: '30px', backgroundColor: '#1E1E1E' }}>
      <Resources />
      <div className="view_code">
        <img src={code} alt="block diagram" className="view_cc1" />
      </div>
    </div>
  );
}

export default Software;
